import { render, staticRenderFns } from "./InputPeopleNum.vue?vue&type=template&id=24fc815f&scoped=true"
import script from "./InputPeopleNum.vue?vue&type=script&lang=js"
export * from "./InputPeopleNum.vue?vue&type=script&lang=js"
import style0 from "./InputPeopleNum.vue?vue&type=style&index=0&id=24fc815f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc815f",
  null
  
)

export default component.exports